/**
 * @function titleCase Transforms any string to title case.
 * In which all words begin with capital letters.
 * EXAMPLE: the red fox jumps --> The Red Fox Jumps
 * @param {String} str The string to be transformed to title case.
 */
export function titleCase(str) {
  return str.replace(/\b(\w)/g, char => char.toUpperCase());
}

/**
 * @function getInitialsFromName Takes in a FIRST and LAST name
 * and returns initials in uppercase.
 * @param firstName
 * @param lastName
 */
export function getInitialsFromFirstAndLast(firstName, lastName) {
  if (!firstName || !lastName) return '';

  const fullName = titleCase(firstName.concat(' ', lastName));

  return fullName.match(/\b(\w)/g).join('').substring(0, 2);
}

export function removeLineBreaks(str) {
  return str.replace(/\r?\n|\r/g, '');
}

export function doesStringHaveLineBreaks(str) {
  return str.match(/\r?\n|\r/g);
}

export function truncateString(string, maxLength) {
  if (string.length <= maxLength) return string;

  const truncatedString = string.substring(0, maxLength);

  return truncatedString.concat('...');
}
